/**
 * Модуль для форматирования данных (даты, числа, текст)
 */

/**
 * Форматирует число с разделителями тысяч
 */
export function formatNumber(number, locale = "ru-RU") {
  if (number == null || !Number.isFinite(Number(number))) {
    return String(number || "");
  }
  return Number(number).toLocaleString(locale);
}

/**
 * Форматирует дату
 */
export function formatDate(date, options = {}) {
  if (!date) return "";
  const dateObj = date instanceof Date ? date : new Date(date);
  if (isNaN(dateObj.getTime())) return "";
  
  const defaultOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    ...options,
  };
  
  return dateObj.toLocaleDateString("ru-RU", defaultOptions);
}

/**
 * Форматирует дату и время
 */
export function formatDateTime(date, options = {}) {
  if (!date) return "";
  const dateObj = date instanceof Date ? date : new Date(date);
  if (isNaN(dateObj.getTime())) return "";
  
  const defaultOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    ...options,
  };
  
  return dateObj.toLocaleString("ru-RU", defaultOptions);
}

/**
 * Форматирует относительное время (например, "2 часа назад")
 */
export function formatRelativeTime(date) {
  if (!date) return "";
  const dateObj = date instanceof Date ? date : new Date(date);
  if (isNaN(dateObj.getTime())) return "";
  
  const now = new Date();
  const diffMs = now.getTime() - dateObj.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);
  
  if (diffSec < 60) return "только что";
  if (diffMin < 60) return `${diffMin} ${diffMin === 1 ? "минуту" : diffMin < 5 ? "минуты" : "минут"} назад`;
  if (diffHour < 24) return `${diffHour} ${diffHour === 1 ? "час" : diffHour < 5 ? "часа" : "часов"} назад`;
  if (diffDay < 7) return `${diffDay} ${diffDay === 1 ? "день" : diffDay < 5 ? "дня" : "дней"} назад`;
  
  return formatDate(dateObj);
}

/**
 * Обновляет еженедельные награды (генерирует случайное число и форматирует его)
 */
export function updateWeeklyRewards(elementId = "weekly-rewards") {
  const element = document.getElementById(elementId);
  if (!element) return;
  
  const randomAmount = Math.floor(Math.random() * 50000) + 10000;
  element.textContent = formatNumber(randomAmount);
}














